<template>
    <!-- <div class="GsLogin" v-if="false"> -->
    <div class="GsLogin" v-if="modals.loginBox">
        <div class="login">
            <div class="login-title">短信登录</div>
            <div class="login-input">
                <input type="text" v-model="phone" placeholder="请输入手机号" />
            </div>
            <div class="login-input">
                <input type="text" v-model="code" @keyup.enter="CheckCode()" placeholder="输入验证码" />
                <a href="JavaScript:;" :class="{ disabled: disabled }" @click="getMyCode()">{{ codeText }}</a>
            </div>
            <template v-if="!isRegister">
                <div class="login-input">
                    <input type="text" v-model="username" placeholder="请输入用户昵称" />
                </div>
                <p class="login-tips">自定义昵称系统将随机分配密码，可通过游民星空app手动修改个人密码</p>
            </template>
            <p class="login-tips">登录即代表同意<a href="#" target="_blank">《游民星空服务条款与隐私条款》</a></p>
            <div class="login-submit" @click="CheckCode()">登录 / 注册</div>
            <div class="login-close" @click="toggleModal('loginBox')"></div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
    name: "GsLogin",
    data() {
        return {
            phone: "",
            code: "",
            VerifyToken: "",
            username: "",
            disabled: false,
            codeText: "获取验证码",
            isRegister: true
        };
    },
    computed: {
        ...mapState(["modals"])
    },
    mounted() {},
    methods: {
        // 验证码倒计时
        getMyCode() {
            if (this.disabled) return;
            if (this.phone == "") {
                this.$toast("手机号不得为空");
                return;
            }
            // 获取验证码
            this.GetVerificationCode();
            let maxNum = 60;
            let oldCodeText = this.codeText;
            this.codeText = `${maxNum}s重新发送`; //初始显示倒计时
            this.disabled = true;
            let codeCountDown = setInterval(() => {
                let countDownNum = maxNum--;
                this.codeText = `${countDownNum}s重新发送`;
                if (countDownNum == 0) {
                    //倒计时结束
                    this.codeText = oldCodeText;
                    clearInterval(codeCountDown);
                    this.disabled = false;
                }
            }, 1000);
        },
        // 获取验证码
        GetVerificationCode() {
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {
                    codetype: 1,
                    phoneNumber: this.phone,
                    email: "",
                    username: ""
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/GetVerificationCode1", JSON.stringify(data)).then(response => {
                if (response.errorCode != 0) {
                    this.$toast(response.errorMessage);
                }
            });
        },
        // 验证短信验证码
        CheckCode() {
            if (this.phone == "") {
                this.$toast("手机号不得为空");
                return;
            }
            if (this.code == "") {
                this.$toast("验证码不得为空");
                return;
            }
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {
                    codeType: 1,
                    phone: this.phone,
                    email: "",
                    veriCode: this.code
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/CheckCode", JSON.stringify(data)).then(response => {
                if (response.errorCode == 0) {
                    this.VerifyToken = response.result.VerifyToken;
                    this.IsEmailAndPhone();
                } else {
                    this.$toast(response.errorMessage);
                }
            });
        },
        // 判断手机号是否已注册
        IsEmailAndPhone() {
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {
                    userInfo: this.phone
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/IsEmailAndPhone", JSON.stringify(data)).then(response => {
                if (response.result.state == 0) {
                    // 已注册
                    this.isRegister = true;
                    this.ThirdPartyLogin();
                } else {
                    // 未注册
                    this.isRegister = false;
                    if (this.username == "") return;
                    this.Register();
                    // this.GetRandomUserName();
                }
            });
        },
        // 获取随机用户名
        GetRandomUserName() {
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {}
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/GetRandomUserName", JSON.stringify(data)).then(response => {
                if (response.errorCode == 0) {
                    this.username = response.result.userName;
                    this.Register();
                } else {
                    this.$toast(response.errorMessage);
                }
            });
        },
        // 注册
        Register() {
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {
                    phoneNumber: this.phone,
                    userName: this.username,
                    password: Math.random()
                        .toString(36)
                        .slice(-10),
                    varifyToken: this.VerifyToken // 来自 CheckCode
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/Register", JSON.stringify(data)).then(response => {
                if (response.errorCode == 0) {
                    this.ThirdPartyLogin(true);
                    this.username = "";
                } else {
                    this.$toast(response.errorMessage);
                }
            });
        },
        // 登录
        ThirdPartyLogin(isRegister) {
            let data = {
                deviceType: "x86_64",
                deviceId: "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
                os: "iOS",
                osVersion: "11.2",
                app: "GSApp",
                appVersion: "3.7.1",
                request: {
                    phoneNumber: this.phone,
                    SMSCode: this.code
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v5/LoginBySMS", JSON.stringify(data)).then(response => {
                if (response.errorCode == 0) {
                    // 登录成功
                    this.$toast("登陆成功");
                    this.LoginUser(1);
                    if(isRegister) {
                        this.RegisteredUser();
                    }
                    this.$utils.logincheck();
                    this.$utils
                        .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                            id: 1479778,
                            script: 3
                        })
                        .then(response => {});
                    setTimeout(() => {
                        window.location.reload(true);
                    }, 1000);
                } else {
                    this.$toast(response.errorMessage);
                }
                this.phone = "";
                this.code = "";
                this.VerifyToken = "";
                this.username = "";
            });
        },
        // 注册埋点
        RegisteredUser() {
            this.$ajax
                .get("//clocktowerevent.gamersky.com/ClockTowerEventStatistics/AddRegisteredUser", {})
                .then(response => {
                    if (response.error == "") {
                    }
                });
        },
        // 登录埋点
        LoginUser(LoginType) {
            this.$ajax
                .get("//clocktowerevent.gamersky.com/ClockTowerEventStatistics/AddLoginUser?LoginType=" + LoginType, {})
                .then(response => {
                    if (response.error == "") {
                    }
                });
        },
        ...mapMutations(["toggleModal"])
    }
};
</script>
<style lang="scss" scoped>
.GsLogin {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    z-index: 5000;
    .login {
        padding: 24px;
        width: 368px;
        background: #ffffff;
        border-radius: 4px;
        box-sizing: border-box;
        .login-title {
            font-size: 22px;
            color: #222;
            text-align: center;
            margin-bottom: 15px;
        }
        .login-input {
            display: flex;
            align-items: center;
            width: 100%;
            height: 40px;
            border: 1px solid #eee;
            border-radius: 4px;
            margin-bottom: 15px;
            input {
                flex: 1;
                display: block;
                border: 0;
                padding: 0 10px;
                outline: none;
            }
            a {
                font-size: 14px;
                color: #1481c2;
                padding: 0 12px;
                text-decoration: none;
                border-left: 1px solid #eee;
                &:hover {
                    color: #eb413d;
                }
                &.disabled {
                    color: #aaa;
                    cursor: unset;
                }
            }
        }
        .login-tips {
            font-size: 12px;
            color: #aaa;
            margin-bottom: 15px;
            a {
                color: #aaa;
                &:hover {
                    color: #eb413d;
                }
            }
        }
        .login-submit {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 40px;
            background: #eb413d;
            color: #ffffff;
            font-size: 16px;
            border-radius: 4px;
            cursor: pointer;
        }
        .login-close {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;
            height: 30px;
            background: url("../assets/login-close.png") no-repeat center / 16px;
            cursor: pointer;
        }
    }
}
</style>
